<script>
    import AdminCreator from './AdminCreator.svelte';
    import AdminFamily from './AdminFamily.svelte';
    import FamilyForm from './FamilyForm.svelte';

    import { db } from './firebase';
    import { collectionData } from 'rxfire/firestore';
    import { startWith } from 'rxjs/operators';

    export let uid;

    const familiesQuery =
        db
            .collection('families')
            .where('owner', '==', uid);
            // .orderBy('name');
    let families = null;
    collectionData(familiesQuery, 'id')
        .subscribe(_f => families = _f);

    let editorFamily = null;
    function edit(ev) {
        const { family } = ev.detail;
        if (editorFamily && (editorFamily.id !== family.id)) {
            alert('Jednu rodinu už právě editujete. Odešlete nebo zrušte, prosím, Vaše změny.');
        } else {
            editorFamily = family;
        }
    }
    function submitEdit() {
        const payload = {...editorFamily};
        delete payload.id;
        delete payload.owner;
        db
            .collection('families')
            .doc(editorFamily.id)
            .update(payload);
        editorFamily = null;
    }
    function cancelEdit() {
        editorFamily = null;
    }

    function doDelete(ev) {
        const { family } = ev.detail;
        const c =
            window.confirm(`Opravdu chcete smazat rodinu '${family.name}'?`);
        if (c) {
            db
                .collection('families')
                .doc(family.id)
                .delete();
        }
    }
</script>

<AdminCreator />

{#if families}
    <div>
        {#each families as family (family.id)}
            <AdminFamily family={family} on:edit={edit} on:delete={doDelete} />
        {/each}
    </div>
{:else}
    Načítám...
{/if}

{#if editorFamily}
    <FamilyForm family={editorFamily} on:cancel={cancelEdit} on:submit={submitEdit} editing={true} />
{/if}